export default "__VITE_ASSET__BLQl57FO__"